import { render, staticRenderFns } from "./ClienteGeral.vue?vue&type=template&id=589625a8"
import script from "./ClienteGeral.vue?vue&type=script&lang=js"
export * from "./ClienteGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports